import app from "flarum/forum/app";
import Button from "flarum/common/components/Button";
import RankDataPage from "../RankDataPage";

enum ZSType {
  KilledZombies = "killed_zombies",
  KilledBosses = "killed_bosses",
  KilledHumans = "killed_humans",
  Repaired = "repaired",
  Healed = "healed",
  ClaimedPoints = "claimed_points",
  RedeemedCounts = "redeemed_counts",
  CreatedNails = "created_nail",
  RemovedNails = "removed_nail",
  DamageProps = "dmg_props",
  DamageZombies = "dmg_zombies",
  DamageHumans = "dmg_humans",
  GotDamage = "got_dmg",
  WinAsHuman = "win_as_human"
}

export default class ZSRankPage extends RankDataPage {
  type = ZSType.KilledZombies as string;

  title(): string {
    return app.translator.trans("rhodes-island.forum.rank.zs_title") as string
  }

  ranksUrl() {
    return "https://rhd-api.tenmahw.com/zs/player/ranks/" + this.type;
  }

  rankUrl(steamid: string) {
    return `https://rhd-api.tenmahw.com/zs/player/rank/${this.type}/?steamid=${steamid}`;
  }

  getTypes(): any[] {
    const types = [];

    for (const i in ZSType) {
      types.push(Button.component({
        // @ts-ignore
        active: this.type === ZSType[i],
        // @ts-ignore
        onclick: () => this.changeType(ZSType[i]),
        // @ts-ignore
      }, app.translator.trans("rhodes-island.forum.zs_data." + ZSType[i])));
    }

    return types;
  }
}
